import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Sun, Moon } from 'lucide-react';
import { useAppTheme } from '../../design/ThemeContext';

/**
 * ThemeToggle - Dark/Light mode toggle button
 */
export default function ThemeToggle({ size = 20 }) {
  const { isDark, toggleMode } = useAppTheme();

  return (
    <Tooltip title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'} arrow>
      <IconButton
        onClick={toggleMode}
        sx={{
          width: 38,
          height: 38,
          borderRadius: '10px',
          border: '1px solid var(--border-primary)',
          backgroundColor: 'var(--bg-input)',
          transition: 'all 0.3s ease',
          '&:hover': {
            backgroundColor: 'rgba(99, 102, 241, 0.12)',
            borderColor: 'var(--border-accent)',
            transform: 'rotate(15deg)',
          },
        }}
      >
        {isDark ? (
          <Sun size={size} style={{ color: 'var(--color-warning)' }} />
        ) : (
          <Moon size={size} style={{ color: 'var(--accent-primary)' }} />
        )}
      </IconButton>
    </Tooltip>
  );
}
